import React from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Ferupen - Premium Barbershop & Grooming</title>
        <meta
          name="description"
          content="Ferupen - Το πιο κομψό barbershop στην Ελλάδα. Προϊόντα premium περιποίησης για τον σύγχρονο κύριο."
        />
      </Helmet>

      <div
        style={{
          padding: "40px 20px",
          maxWidth: "1200px",
          margin: "0 auto",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <h1
          style={{
            color: "#3E2723",
            marginBottom: "30px",
            fontSize: "2.5em",
            textAlign: "center",
          }}
        >
          Πολιτική Απορρήτου
        </h1>

        <section style={{ marginBottom: "30px" }}>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Η Ferupen δεσμεύεται να προστατεύει το απόρρητο των επισκεπτών και
            πελατών της. Αυτή η Πολιτική Απορρήτου εξηγεί πώς συλλέγουμε,
            χρησιμοποιούμε, αποκαλύπτουμε και προστατεύουμε τις πληροφορίες σας
            όταν χρησιμοποιείτε τον ιστότοπό μας ferupen.com.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            1. Πληροφορίες που Συλλέγουμε
          </h2>
          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            1.1 Προσωπικά Δεδομένα
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Κατά την παραγγελία προϊόντων ή την εγγραφή στο newsletter μας,
            μπορεί να σας ζητηθεί να παράσχετε:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Ονοματεπώνυμο</li>
            <li>Διεύθυνση email</li>
            <li>Αριθμό τηλεφώνου (+302299022996)</li>
            <li>
              Διεύθυνση αποστολής (Οδός Αντωνόπουλος 38, Μαρκόπουλο Μεσογαίας,
              51842)
            </li>
            <li>
              Στοιχεία πληρωμής (επεξεργάζονται με ασφάλεια από τρίτους
              παρόχους)
            </li>
          </ul>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            1.2 Δεδομένα Χρήσης
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Συλλέγουμε αυτόματα πληροφορίες σχετικά με την επίσκεψή σας:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Διεύθυνση IP</li>
            <li>Τύπος προγράμματος περιήγησης</li>
            <li>Σελίδες που επισκέπτεστε</li>
            <li>Χρόνος και ημερομηνία επίσκεψης</li>
            <li>Χρόνος που αφιερώνετε σε κάθε σελίδα</li>
          </ul>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            1.3 Cookies και Τεχνολογίες Παρακολούθησης
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Χρησιμοποιούμε cookies, web beacons και άλλες τεχνολογίες
            παρακολούθησης για:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Google Analytics για ανάλυση επισκεψιμότητας</li>
            <li>Facebook Pixel για διαφημιστικούς σκοπούς</li>
            <li>
              Cookies περιόδου σύνδεσης για τη διατήρηση των προτιμήσεών σας
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            2. Πώς Χρησιμοποιούμε τις Πληροφορίες σας
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Χρησιμοποιούμε τα δεδομένα που συλλέγουμε για:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Επεξεργασία και εκτέλεση των παραγγελιών σας</li>
            <li>
              Επικοινωνία σχετικά με τις παραγγελίες και τις υπηρεσίες μας
            </li>
            <li>
              Αποστολή προωθητικών emails και ενημερώσεων (με τη συγκατάθεσή
              σας)
            </li>
            <li>Βελτίωση της εμπειρίας χρήσης του ιστότοπου</li>
            <li>Ανάλυση και κατανόηση των προτιμήσεων των πελατών</li>
            <li>Πρόληψη απάτης και βελτίωση της ασφάλειας</li>
            <li>Συμμόρφωση με νομικές υποχρεώσεις</li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            3. Κοινοποίηση Πληροφοριών
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Δεν πουλάμε, ανταλλάσσουμε ή μεταβιβάζουμε με άλλο τρόπο τα
            προσωπικά σας δεδομένα σε τρίτους, εκτός από τις ακόλουθες
            περιπτώσεις:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>Παρόχους Υπηρεσιών:</strong> Συνεργάτες που μας βοηθούν
              στη λειτουργία του ιστότοπου (hosting, email marketing, ανάλυση
              δεδομένων)
            </li>
            <li>
              <strong>Επεξεργαστές Πληρωμών:</strong> Ασφαλείς πύλες πληρωμών
              για την επεξεργασία συναλλαγών
            </li>
            <li>
              <strong>Μεταφορικές Εταιρείες:</strong> Για την παράδοση των
              προϊόντων σας
            </li>
            <li>
              <strong>Νομικές Απαιτήσεις:</strong> Όταν απαιτείται από το νόμο ή
              για την προστασία των δικαιωμάτων μας
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            4. Ασφάλεια Δεδομένων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Λαμβάνουμε σοβαρά υπόψη την ασφάλεια των προσωπικών σας δεδομένων.
            Εφαρμόζουμε:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Κρυπτογράφηση SSL/TLS για όλες τις μεταδόσεις δεδομένων</li>
            <li>Ασφαλείς διακομιστές και προστασία με firewall</li>
            <li>
              Περιορισμένη πρόσβαση στα προσωπικά δεδομένα μόνο σε
              εξουσιοδοτημένο προσωπικό
            </li>
            <li>Τακτικές επισκοπήσεις ασφαλείας και ενημερώσεις συστημάτων</li>
          </ul>
          <p
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              fontStyle: "italic",
            }}
          >
            Ωστόσο, καμία μέθοδος μετάδοσης μέσω Internet ή ηλεκτρονικής
            αποθήκευσης δεν είναι 100% ασφαλής. Δεν μπορούμε να εγγυηθούμε
            απόλυτη ασφάλεια.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            5. Τα Δικαιώματά σας (GDPR)
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), έχετε
            τα ακόλουθα δικαιώματα:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>Δικαίωμα Πρόσβασης:</strong> Να ζητήσετε αντίγραφα των
              προσωπικών σας δεδομένων
            </li>
            <li>
              <strong>Δικαίωμα Διόρθωσης:</strong> Να ζητήσετε διόρθωση
              ανακριβών δεδομένων
            </li>
            <li>
              <strong>Δικαίωμα Διαγραφής:</strong> Να ζητήσετε διαγραφή των
              προσωπικών σας δεδομένων
            </li>
            <li>
              <strong>Δικαίωμα Περιορισμού:</strong> Να ζητήσετε περιορισμό της
              επεξεργασίας
            </li>
            <li>
              <strong>Δικαίωμα Φορητότητας:</strong> Να ζητήσετε μεταφορά
              δεδομένων σε άλλο οργανισμό
            </li>
            <li>
              <strong>Δικαίωμα Εναντίωσης:</strong> Να αντιταχθείτε στην
              επεξεργασία των δεδομένων σας
            </li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Για να ασκήσετε οποιοδήποτε από αυτά τα δικαιώματα, επικοινωνήστε
            μαζί μας στο:
            <strong>
              {" "}
              <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
            </strong>{" "}
            ή καλέστε στο <strong>+302299022996</strong>
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            6. Cookies
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Ο ιστότοπός μας χρησιμοποιεί cookies για τη βελτίωση της εμπειρίας
            σας. Οι τύποι cookies που χρησιμοποιούμε:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>Απολύτως Απαραίτητα Cookies:</strong> Απαραίτητα για τη
              λειτουργία του ιστότοπου
            </li>
            <li>
              <strong>Λειτουργικά Cookies:</strong> Αποθηκεύουν τις προτιμήσεις
              σας
            </li>
            <li>
              <strong>Αναλυτικά Cookies:</strong> Μας βοηθούν να κατανοήσουμε
              πώς χρησιμοποιείτε τον ιστότοπο (Google Analytics)
            </li>
            <li>
              <strong>Διαφημιστικά Cookies:</strong> Χρησιμοποιούνται για
              στοχευμένες διαφημίσεις (Facebook Pixel)
            </li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Μπορείτε να απενεργοποιήσετε τα cookies μέσω των ρυθμίσεων του
            προγράμματος περιήγησής σας, αλλά αυτό μπορεί να επηρεάσει τη
            λειτουργικότητα του ιστότοπου.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            7. Υπηρεσίες Τρίτων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Ο ιστότοπός μας μπορεί να περιέχει συνδέσμους προς ιστότοπους
            τρίτων:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Google Analytics</li>
            <li>Facebook Business</li>
            <li>Πύλες πληρωμών</li>
            <li>Πλατφόρμες social media</li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Δεν είμαστε υπεύθυνοι για τις πρακτικές απορρήτου αυτών των τρίτων.
            Σας ενθαρρύνουμε να διαβάσετε τις πολιτικές απορρήτου τους.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            8. Διατήρηση Δεδομένων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Διατηρούμε τα προσωπικά σας δεδομένα όσο χρόνο είναι απαραίτητο για:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              Την εκπλήρωση των σκοπών που περιγράφονται σε αυτήν την πολιτική
            </li>
            <li>Τη συμμόρφωση με νομικές και φορολογικές υποχρεώσεις</li>
            <li>Την επίλυση διαφορών και την επιβολή των συμφωνιών μας</li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Συνήθως διατηρούμε δεδομένα πελατών για 7 χρόνια μετά την τελευταία
            συναλλαγή, εκτός εάν απαιτείται διαφορετικά από το νόμο.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            9. Ανήλικοι
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Ο ιστότοπός μας δεν απευθύνεται σε άτομα κάτω των 18 ετών. Δεν
            συλλέγουμε εν γνώσει μας προσωπικά δεδομένα από παιδιά. Εάν είστε
            γονέας ή κηδεμόνας και πιστεύετε ότι το παιδί σας μας έχει παράσχει
            προσωπικά δεδομένα, επικοινωνήστε μαζί μας για να τα διαγράψουμε.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            10. Αλλαγές στην Πολιτική Απορρήτου
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Μπορούμε να ενημερώνουμε την Πολιτική Απορρήτου μας κατά καιρούς. Θα
            σας ειδοποιήσουμε για οποιεσδήποτε αλλαγές δημοσιεύοντας τη νέα
            Πολιτική Απορρήτου σε αυτήν τη σελίδα και ενημερώνοντας την
            ημερομηνία "Τελευταία Ενημέρωση" παρακάτω.
          </p>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Σημαντικές αλλαγές θα κοινοποιούνται μέσω email στους εγγεγραμμένους
            χρήστες.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            11. Επικοινωνία
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Για ερωτήσεις ή ανησυχίες σχετικά με αυτήν την Πολιτική Απορρήτου ή
            τις πρακτικές προστασίας δεδομένων μας, επικοινωνήστε μαζί μας:
          </p>
          <div
            style={{
              backgroundColor: "#F5F5F5",
              padding: "20px",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Ferupen Barbershop</strong>
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Οδός Αντωνόπουλος 38
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Μαρκόπουλο Μεσογαίας, 51842
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Ελλάδα
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Email:</strong>{" "}
              <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Τηλέφωνο:</strong> +302299022996
            </p>
          </div>
        </section>

        <section
          style={{
            marginBottom: "30px",
            paddingTop: "20px",
            borderTop: "2px solid #3E2723",
          }}
        >
          <p
            style={{
              lineHeight: "1.8",
              color: "#555",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            <strong>Τελευταία Ενημέρωση:</strong> Ιανουάριος 2025
          </p>
          <p
            style={{
              lineHeight: "1.8",
              color: "#555",
              textAlign: "center",
              marginTop: "15px",
            }}
          >
            Με τη χρήση του ιστότοπου Ferupen, συμφωνείτε με τους όρους αυτής
            της Πολιτικής Απορρήτου.
          </p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
